module.exports = __webpack_public_path__ + "media/application/images/2023/02_still-1250x703-e4c5a1d556d354196787272f9ff9cd2c.png";